export default __webpack_public_path__ + "static/media/angina_inestable.8625a825.pdf";